import Roles from '@/shared/utils/roles.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import { loading, toast } from '@/shared/utils/UIHelper'
import FormSearch from './search-form.js'
import NxDatePicker from '@/components/forms/NxDatePicker.vue'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import KmValueRepository from '@/shared/http/repositories/configurations/kmvalue.js'
import { JWTService } from '@/shared/services/jwt'

const DataSearch = {
  usuarioId: null,
  periodoId: null
}

export default {
  name: 'ReportDespesasSearch',
  mixins: [ActionsForm],
  components: {
    NxDatePicker
  },
  data () {
    return {
      data: DataSearch,
      form: FormSearch,
      roles: Roles,
      permissions: null
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
      this.onClear()
      this.permissions = JWTService.GetRoles()
      this.onLoadEmployeesFromUser()
      this.onLoadKmValue()
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onClearFilters () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onFilter () {
      Tools.SetValueToSave(this.form, this.data)

      if (this.validateFilter()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    },
    validateFilter () {
      const allFieldsFilled = Object.values(this.data).filter(x => x === null || x === undefined).length === 0

      if (!allFieldsFilled) {
        toast.warning('Preencha todos os campos para pesquisar')
        return false
      }

      return true
    },
    mapSelectedValues (item) {
      if (!item) {
        return undefined
      }

      if (item.selected && item.selected.length > 0) {
        return item.selected.map(i => i.value)
      }

      if (item.value) {
        return item.value.value
      }

      return undefined
    },
    async onLoadKmValue () {
      loading.push()

      await KmValueRepository.GetAll()
        .then((res) => {
          this.form.periodoId.options = res.data.content
            .map((x) => ({'value': x.id, 'text': `${x.dataInicial} - ${x.dataFinal}`}))
        })
        .catch(err => console.error(err))

      loading.pop()
    },
    async onLoadEmployee () {
      loading.push()

      await EmployeeRepository.GetAll()
        .then((res) => {
          this.form.usuarioId.options = res.data.content
            .filter((x) => x.usuarioId != null)
            .map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome.toUpperCase()}))
        })
        .catch(err => console.error(err))

      loading.pop()
    },
    async onLoadEmployeesFromUser () {
      loading.push()

      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        await this.onLoadEmployee()
      } else {
        await AccountRepository.GetAllFromUser()
          .then((res) => {
            this.form.usuarioId.options = res.data
              .filter((x) => x.usuarioId != null)
              .map((x) => ({'value': x.usuarioId, 'text': x.associado.pessoa.nome.toUpperCase()}))
          })
          .catch(err => console.error(err))
      }

      loading.pop()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/visitas/reports/despesas/search/search.js